/* eslint-disable no-console */
import _get from 'lodash/get';
import SeoParameter from './SeoParameter';
const seoParamRegex = new RegExp(/:(seo[A-Z,a-z]+)\??/);
const paramRegex = new RegExp(/:([A-Z,a-z]+)\??/);
const paramGroupRegex = new RegExp(/^\[(.*)\]$/);
export default class PathSegment {
  constructor(_ref) {
    let {
      segment,
      query,
      pathname
    } = _ref;
    this.segment = segment;
    this.query = query;
    this.pathname = pathname;
    this.param = undefined;
    this.type = undefined;
    this.pattern = undefined;
    this.match(segment);
  }
  match() {
    const matchers = [{
      regex: paramGroupRegex,
      type: 'paramGroup'
    }, {
      regex: seoParamRegex,
      type: 'seoParam'
    }, {
      regex: paramRegex,
      type: 'param'
    }];
    matchers.some(_ref2 => {
      let {
        regex,
        type
      } = _ref2;
      const match = this.segment.match(regex);
      if (match) {
        const [pattern, slug] = match;
        this.type = type;
        this.slug = slug;
        this.pattern = pattern;
      } else {
        this.type = 'string';
        this.slug = this.segment;
      }
      return match;
    });
  }
  is(type) {
    return type === this.type;
  }
  parseParamGroup() {
    return this.slug.split('||');
  }
  async _processParamGroup() {
    try {
      // obtain the segments to process
      // and the whole match so we can update it in the pathname later
      const segments = this.parseParamGroup();
      const result = await segments.reduce(async (_acc, segment) => {
        const acc = await _acc;
        if (!acc.updated) {
          const pathSegment = new PathSegment({
            segment,
            query: {
              ...acc.segment.query
            },
            pathname: acc.segment.pathname
          });
          const processedResult = await pathSegment.process();

          // if the keys of our query object have changed then
          // then we can assume we need to update the acc and
          // bail out of further checks
          if (Object.keys(acc.segment.query).join('') !== Object.keys(processedResult.query).join('')) {
            acc.updated = true;
            acc.segment = pathSegment;
          }
        }
        return acc;
      }, Promise.resolve({
        updated: false,
        segment: this
      }));
      if (result.updated) {
        const originalSegment = this.segment;
        Object.assign(this, result.segment);
        this.pathname = this.pathname.replace(originalSegment, this.segment);
      } else {
        this.pathname = this.pathname.replace(this.segment, '');
      }
    } catch (err) {
      console.error(err);
      // TODO: do we want to throw an error here?
    }
  }
  async process() {
    switch (this.type) {
      case 'paramGroup':
        {
          await this._processParamGroup();
          return this;
        }
      case 'seoParam':
        {
          const seoParam = new SeoParameter(this.segment);
          switch (seoParam.param) {
            case 'listingId':
              {
                // listingId can be passsed as string or number and doesn't require any additional encoding
                if (this.query.listingId && (typeof this.query.listingId === 'string' || typeof this.query.listingId === 'number')) {
                  this.query[seoParam.encodedParam] = this.query.listingId;
                  delete this.query.listingId;
                }
                break;
              }
            case 'location':
              {
                if (this.query.zip || this.query.city && this.query.state) {
                  const encodedValue = await seoParam.encodeValue(this.query, {
                    req: this.req
                  });
                  this.query[seoParam.encodedParam] = encodedValue;
                  delete this.query.city;
                  delete this.query.state;
                }
                break;
              }
            case 'price':
              {
                if (this.query.minPrice > 0 || this.query.maxPrice > 0) {
                  const encodedValue = await seoParam.encodeValue(this.query);
                  this.query[seoParam.encodedParam] = encodedValue;
                  delete this.query.minPrice;
                  delete this.query.maxPrice;
                }
                break;
              }
            case 'year':
              {
                if (this.query.startYear && this.query.endYear && this.query.startYear === this.query.endYear) {
                  const encodedValue = await seoParam.encodeValue(this.query);
                  this.query[seoParam.encodedParam] = encodedValue;
                  delete this.query.startYear;
                  delete this.query.endYear;
                }
                break;
              }
            case 'moneyBackGuarantee':
              {
                if (this.query.vehicleExchange) {
                  this.query[seoParam.encodedParam] = 'money-back-guarantee';
                  delete this.query.vehicleExchange;
                }
                break;
              }
            case 'commercialVehicles':
              {
                if (this.query.vehicleUseType && this.query.vehicleUseType.includes('COMMERCIAL') && !this.query.vehicleUseType.includes('PERSONAL')) {
                  this.query[seoParam.encodedParam] = 'commercial-vehicles';
                  delete this.query.vehicleUseType;
                }
                break;
              }
            default:
              {
                const value = [].concat(_get(this.query, seoParam.param, []));

                // modelCode and seriesCode should not be seo-encoded
                // if there is anything besides 1 makeCode selected
                if (['modelCode', 'seriesCode', 'trimCode'].includes(seoParam.param)) {
                  const makeCode = [].concat(_get(this.query, 'makeCode', []));
                  if (makeCode.length !== 1) {
                    break;
                  }
                }
                if (['trimCode'].includes(seoParam.param)) {
                  const modelCode = [].concat(_get(this.query, 'modelCode', []));
                  const seriesCode = [].concat(_get(this.query, 'seriesCode', []));
                  if (modelCode.length !== 1 || seriesCode.length > 1) {
                    break;
                  }
                }
                if (value.length === 1 && typeof value[0] === 'string') {
                  const encodedValue = await seoParam.encodeValue(value[0], this.query);
                  this.query[seoParam.encodedParam] = encodedValue;
                  delete this.query[seoParam.param];
                }
                break;
              }
          }
          this.param = seoParam.param;
          return this;
        }
      default:
    }
    return this;
  }
}